import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ num, label }) => (
  <div className="mb-4 flex items-center gap-4" data-testid={`chapter-${num}`}>
    <span className="font-mono-tech text-xs font-semibold tracking-[0.25em] text-[#FF5B00]">{num}</span>
    <span className="h-px w-10 bg-[#FF5B00]" />
    <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#94A3B8]">{label}</span>
  </div>
);
